function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86 6C90.1625 6.21764 93.8784 7.69297 96.9561 10.5858C99.9493 13.3983 101.796 17.438 101.984 21.5805C102.172 25.723 100.698 29.9184 97.9722 33C97.6851 28.9178 96.3147 24.9206 94.0449 21.5427C92.351 19.0209 90.0276 16.9272 88.6485 14.1886C87.4319 11.7728 87.7018 8.0865 86 6Z",
  fill: "#3E1641"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.3851 90C89.1915 88.498 86.151 78.8469 85.9687 77.3433C85.4184 72.7888 84.9203 68.2295 84.4745 63.6629C84.2528 61.3797 84.0431 59.0956 83.8471 56.8108C83.6623 54.6576 83.541 52.5108 83.4671 50.368C84.4512 50.5196 85.3316 51.2969 86.2153 51.7486C89.4664 53.4118 97.67 57.8858 99.8157 52.5355C100.968 49.6617 101.305 46.1502 101.633 43.1056C102.304 36.8696 102.036 30.5321 100.981 24.3527C98.5729 10.2653 77.1843 0.319055 65.299 9.62447C56.7982 16.2803 55.3972 29.9384 62.8207 37.8224C65.4171 40.5806 68.6529 42.6659 71.7144 44.8669C71.818 44.942 71.9273 45.0226 71.9731 45.1423C72.0148 45.2516 71.9964 45.3729 71.9771 45.4878C71.7337 46.9507 71.5136 48.3736 71.2517 49.8149C70.4379 54.3144 69.8587 58.7947 68.7188 63.2304C66.8671 70.4337 61.481 82.898 59.2775 90H89.3851Z",
  fill: "#F6B9A6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.1993 2.81987C69.0508 -0.77638 77.369 -0.564096 85.1055 1.40071C87.5731 2.02734 90.9897 3.01564 92.8045 4.88531C98.4013 10.6524 95.7278 19.7774 91.7797 25.6278C88.4095 30.622 82.8972 34.8802 76.5718 34.9313C74.9692 31.1228 65.9678 28.3765 68.0189 34.8763C68.868 37.5684 71.7826 39.0567 74.5423 39.8021C75.132 39.9609 73.1752 50.0774 72.9294 51.0523C71.9869 54.7893 70.5041 57.3862 68.2256 60.3519C65.0588 64.4742 61.0206 70.139 55.2163 70.455C52.6162 70.5974 49.9546 70.0643 47.4311 70.7011C42.7345 71.8844 39.6867 76.7937 34.9517 77.8213C32.2327 78.411 29.2304 77.5139 27.3014 75.5349C26.086 74.2872 25.2249 72.6141 23.6479 71.853C20.9161 70.5345 17.1668 72.5056 14.7885 70.6359C12.0121 68.4541 13.9761 63.868 9.77109 62.8191C8.50136 62.5015 7.163 62.5754 5.87971 62.3222C3.83825 61.9197 1.98673 60.6538 0.890187 58.9107C-0.304521 57.0128 -0.427423 54.2067 1.33152 52.797C2.00668 52.256 2.86461 51.9895 3.59643 51.5248C6.86053 49.4547 6.85255 44.1342 10.3194 42.4139C13.1717 40.9995 16.7159 42.8912 19.7717 41.9768C22.1252 41.2723 23.6782 39.0402 24.5465 36.7735C25.414 34.5052 25.7923 32.0647 26.8186 29.8625C28.5249 26.1978 32.0643 23.4169 36.0698 22.5937C40.9516 21.5905 45.7671 21.3161 49.6888 17.7623C52.8636 14.8862 53.2754 10.6193 56.2035 7.43979C58.0119 5.47499 60.0326 3.95676 62.1993 2.81987Z",
  fill: "#3E1641"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.4515 24.4539C87.4821 24.4539 86.6076 24.7845 85.8418 25.4432C83.8988 27.1139 83.0208 30.4579 83.0269 32.857C83.0338 35.5919 84.2251 38.1963 86.1351 39.6564C88.2087 41.2392 90.8992 41.3523 92.9937 39.9409C93.2138 39.793 93.427 39.6277 93.6272 39.4493C95.3805 37.89 95.4623 34.4528 95.4458 33.4365C95.3823 29.6 92.9571 25.0952 89.1493 24.5087C88.9118 24.4721 88.6786 24.4539 88.4515 24.4539ZM89.8012 42.6498C88.1452 42.6498 86.4798 42.1094 85.0797 41.0391C82.7129 39.2318 81.2954 36.1749 81.2867 32.8614C81.2788 29.9829 82.3343 26.1646 84.7073 24.1233C86.0369 22.9807 87.6614 22.5169 89.4148 22.7884C94.1815 23.5228 97.1096 28.7647 97.1862 33.4078C97.2114 34.9506 97.0278 38.755 94.7837 40.7502C94.5252 40.9791 94.2503 41.1931 93.9649 41.3854C92.7101 42.2304 91.2595 42.6498 89.8012 42.6498Z",
  fill: "#1D1D1B"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.32 21.3142C102.959 21.3142 102.617 21.4291 102.271 21.6623C100.715 22.7143 99.6391 25.8469 99.4163 28.2598C99.1953 30.6641 99.7775 33.0161 100.937 34.3979C102.096 35.7815 103.678 36.0234 105.065 35.0279C105.218 34.9183 105.367 34.7938 105.513 34.6563C106.388 33.8219 107.028 31.8945 107.223 29.5041C107.494 26.154 106.217 22.1 103.883 21.4021C103.689 21.3438 103.502 21.3142 103.32 21.3142ZM103.311 37.3763C101.958 37.3763 100.631 36.7428 99.6028 35.5159C98.1348 33.7651 97.4178 30.9928 97.6841 28.0995C97.9408 25.3072 99.1816 21.6508 101.298 20.2202C102.242 19.5815 103.308 19.4136 104.383 19.7347C107.67 20.7171 109.29 25.5447 108.957 29.6449C108.821 31.3174 108.349 34.3568 106.712 35.917C106.507 36.1119 106.296 36.2868 106.082 36.4409H106.081C105.207 37.0691 104.252 37.3763 103.311 37.3763Z",
  fill: "#1D1D1B"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.291 32.4055L95.8716 30.7165L98.3219 30.1074L98.7422 31.7964L96.291 32.4055Z",
  fill: "#1D1D1B"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.1845 33.1285L74.3601 31.6605C73.0853 31.4221 71.7696 31.1767 70.5096 31.2646C69.7508 31.3186 68.3429 31.5613 67.4275 32.582L66.1318 31.4204C67.1134 30.3257 68.6248 29.654 70.386 29.5287C71.867 29.4225 73.2985 29.6914 74.6803 29.9507L82.5047 31.4178L82.1845 33.1285Z",
  fill: "#1D1D1B"
});

var SvgHead1 = function SvgHead1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 109,
    height: 90,
    viewBox: "0 0 109 90",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHead1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/head-1.d79d5c84.svg";
export { ForwardRef as ReactComponent };